<template>
  <CardWithTitle
    :item-id="itemId"
    :request-status="requestStatus"
    :has-custom-filter="hasCustomFilter"
    :options-data="cardOptionsWithCSVExportOption"
    @call-option-menu="callOptionMenu"
    @reload="$emit('reload', $event)"
  >
    <v-row
      no-gutters
      class="multibar-chart-container fill-height"
      justify="center"
    >
      <HighCharts
        v-if="series.length"
        :ref="chartRef"
        :key="itemId"
        class="multibar-chart"
        :options="chartOptions"
      />
    </v-row>
    <template #top-right-slot>
      <template v-if="hasCustomFilter">
        <DsButton
          v-tooltip="filterButton"
          color="tertiary"
          name="filter"
          :icon="true"
          @click="openFilter"
        />
      </template>
      <slot name="top-right-slot" />
      <Badge
        v-if="hasFilterApplied && isEditor"
        type="info"
        :tooltip="$t('components.Badge.label.tooltip.info')"
        :value="$t('components.Badge.label.icon.key')"
        :preset="true"
      />
    </template>
  </CardWithTitle>
</template>

<script>
import { Chart } from 'highcharts-vue';
import highChartsBasics from '@/mixins/highcharts-basics';
import exportModel from '@/mixins/export-model';
import cardsModel from '@/mixins/cards-model';
import CardWithTitle from '@/components/cards/models/CardWithTitle';
import merge from 'lodash/merge';
import Badge from '@/components/Badge';
import { DsButton } from '@ds/components';

export default {
  name: 'BarChart',
  components: {
    HighCharts: Chart,
    CardWithTitle,
    Badge,
    DsButton,
  },
  mixins: [
    highChartsBasics,
    cardsModel,
    exportModel,
  ],
  props: {
    requestStatus: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    series: {
      type: [Array, Object],
      default: () => ([]),
    },
    categories: {
      type: [Array, Object],
      default: () => ([]),
    },
    cardOptions: {
      type: [Array, Object],
      default: () => ([]),
    },
    hasCustomFilter: {
      type: Boolean,
      default: false,
    },
    openFilter: {
      type: Function,
      default: () => {},
    },
    openDialog: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      filterButton: this.$t('components.OperatorsLogs.filterLabel'),
    };
  },
  computed: {
    chartOptions() {
      const customOptions = {
        chart: {
          type: 'bar',
        },
        xAxis: {
          categories: this.categories,
          type: 'category',
          lineWidth: 0,
          tickLength: 0,
        },
        yAxis: {
          gridLineColor: 'transparent',
          min: 0,
          title: '',
          tickColor: 'transparent',
          labels: {
            enabled: false,
          },
          stackLabels: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            borderColor: 'black',
            borderWidth: 0.5,
            pointPadding: 0,
          },
        },
        legend: {
          enabled: false,
        },
        series: this.series,
      };
      return merge({}, this.highchartsBasics, this.highchartTheme, customOptions, this.cardOptions);
    },
  },
};
</script>

<style scoped lang="scss">
  .multibar-chart {
    width: 100%;
  }
</style>
